const SUBSCRIBE_DIALOG_TIMEOUT = 45000;
const LOCAL_STORAGE_ITEM = 'wiki_subscribe_dialog';

export default class SubscribeDialog {
    constructor(context) {
        this.context = context;

        this.overlay = this.context.querySelector('[data-dialog-overlay]');
        this.dialog = this.context.querySelector('[data-dialog]');
        this.closeButton = this.context.querySelector('[data-dialog-close]');

        this.shouldShow = !this.checkLocalStorage();

        if (this.shouldShow) {
            const { overflow, paddingRight } = window.getComputedStyle(document.body);

            this.initialOverflow = overflow;
            this.initialPaddingRight = paddingRight;

            setTimeout(this.handleOpen, SUBSCRIBE_DIALOG_TIMEOUT);

            this.closeButton.addEventListener('click', this.handleClose);
        }
    }

    checkLocalStorage = () => {
        try {
            return localStorage.getItem(LOCAL_STORAGE_ITEM) || false;
        } catch (error) {
            return true;
            console.log(error);
        }
    };

    handleOpen = () => {
        document.body.style.overflow = 'hidden';

        if (this.overlay.clientWidth !== window.innerWidth) {
            document.body.style.paddingRight = '15px';
        }

        this.dialog.classList.add('open');
        this.overlay.classList.add('show');
    };

    handleClose = (e) => {
        if (!this.checkLocalStorage()) {
            localStorage.setItem(LOCAL_STORAGE_ITEM, 1);
        }

        document.body.style.overflow = this.initialOverflow;
        document.body.style.paddingRight = this.initialPaddingRight;
        this.overlay.classList.remove('show');
        this.dialog.classList.remove('open');
    };
}
